import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import { UpperCasePipe } from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";

@Component({
	selector: 'app-select-quantity-modal',
	standalone: true,
	imports: [
    MatDialogTitle,
    ReactiveFormsModule,
    TranslateModule,
    UpperCasePipe,
    FormsModule
],
	templateUrl: './select-quantity-modal.component.html',
	styleUrl: './select-quantity-modal.component.scss'
})
export class SelectQuantityModalComponent implements OnInit {
	private _dialogRef = inject(MatDialogRef<SelectQuantityModalComponent>);
	private _dialogConfig = inject(MAT_DIALOG_DATA);

	selectedQuantity: number = 0;
	quantityList: Array<number> = [];

	ngOnInit(): void {
		this.quantityList = this._dialogConfig.quantityList;
		this.selectedQuantity = this._dialogConfig.selectedQuantity;
	}

	onSelectQuantity(quantity?: number): void {
		this._dialogRef.close(quantity);
	}
}
